import React, { useState, useEffect } from 'react';

const MonthField = ({ handleBlur, handleChange, date }) => {
  return (
    <label className="form-group__input-label form-group__input-label--month">
      <span className="form-group__label-text">
        Month <span className="sr-only">of birth</span>
      </span>
      <input
        className="form-group__input"
        placeholder="MM"
        type="text"
        maxLength={2}
        name="month"
        onBlur={handleBlur}
        onChange={handleChange}
        value={date.month}
        autoComplete="bday-month"
      />
    </label>
  );
};

const DateOfBirth = ({
  dobUpdate,
  dobError,
  profileData,
  updateProfile,
  showAgeCheckbox,
  country,
}) => {
  const [date, setDate] = useState(
    (profileData && profileData.split_date_of_birth) || {
      day: '',
      month: '',
      year: '',
    },
  );
  const [showAge, setShowAge] = useState(true);
  const [errorMessage, setErrorMessage] = useState(dobError);

  useEffect(() => {
    setErrorMessage(dobError);
  }, [dobError]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDate({ ...date, [name]: value.trim() });
  };

  const handleBlur = () => {
    dobUpdate(date);
  };

  const handleCheckboxChange = (event) => {
    setShowAge(event.currentTarget.checked);
    updateProfile('hide_age', !event.currentTarget.checked);
  };

  return (
    <fieldset className="form-group from-group--date-of-birth form-group--no-validation">
      <legend className="form-group__title">Date of birth</legend>
      <span className="form-group__inline" id="basicProfileDob">
        {country === 'US' ? (
          <MonthField
            handleBlur={handleBlur}
            handleChange={handleChange}
            date={date}
          />
        ) : null}
        <label className="form-group__input-label">
          <span className="form-group__label-text">
            Day <span className="sr-only">of birth</span>
          </span>
          <input
            className="form-group__input"
            placeholder="DD"
            type="text"
            maxLength={2}
            name="day"
            onBlur={handleBlur}
            onChange={handleChange}
            value={date.day}
            autoComplete="bday-day"
          />
        </label>
        {country !== 'US' ? (
          <MonthField
            handleBlur={handleBlur}
            handleChange={handleChange}
            date={date}
          />
        ) : null}
        <label className="form-group__input-label">
          <span className="form-group__label-text">
            Year <span className="sr-only">of birth</span>
          </span>
          <input
            className="form-group__input form-group__input--year"
            placeholder="YYYY"
            type="text"
            maxLength={4}
            name="year"
            onBlur={handleBlur}
            onChange={handleChange}
            value={date.year}
            autoComplete="bday-year"
          />
        </label>
        <p className="form-group__date-error" aria-live="assertive">
          {errorMessage}
        </p>
        {showAgeCheckbox && (
          <span className="form-group__checkbox form-group__checkbox--show-age">
            <input
              type="checkbox"
              name="hide_age"
              id="hideAge"
              checked={showAge}
              onChange={handleCheckboxChange}
            ></input>
            <label htmlFor="hideAge">
              Show age on profile{' '}
              <span className="form-group__show-age-hint">(recommended)</span>
            </label>
          </span>
        )}
      </span>
    </fieldset>
  );
};

export default DateOfBirth;
